import styled, { css } from "styled-components";
import { theme } from "../../../../../../../../common-deprecated/styles/v2/lexus/theme/lexusTheme";

const commonStyles = css`
    color: ${theme.colors.platinumDark};
`;

export const Wrapper = styled.div<{ show: boolean }>`
    margin-bottom: ${theme.space[2]}px;
    text-align: center;
    transition: opacity 0.15s;
    opacity: ${(props) => (props.show ? 1 : 0)};
`;

export const PreCount = styled.span.attrs(() => ({
    className: "l-nano-text",
}))`
    ${commonStyles};
`;

export const Count = styled.span.attrs(() => ({
    className: "l-micro-text",
}))`
    ${commonStyles};
`;

export const Label = styled.span.attrs(() => ({
    className: "l-nano-text",
}))`
    ${commonStyles};
`;
